module.exports = {
          srcSet: "/_next/static/images/img-voitures@2x-160-f7c6e387021e5d625f54d2d7931bae0c.jpg"+" 160w"+","+"/_next/static/images/img-voitures@2x-292-9d773d2baf86183474fafc1eeb59252f.jpg"+" 292w",
          images:[ {path: "/_next/static/images/img-voitures@2x-160-f7c6e387021e5d625f54d2d7931bae0c.jpg",width: 160,height: 137},{path: "/_next/static/images/img-voitures@2x-292-9d773d2baf86183474fafc1eeb59252f.jpg",width: 292,height: 250}],
          src: "/_next/static/images/img-voitures@2x-160-f7c6e387021e5d625f54d2d7931bae0c.jpg",
          toString:function(){return "/_next/static/images/img-voitures@2x-160-f7c6e387021e5d625f54d2d7931bae0c.jpg"},
          placeholder: undefined,
          width: 160,
          height: 137
      }